import React, { forwardRef } from 'react';
import { Controller, get, useFormContext } from 'react-hook-form';
import InputMask from 'react-input-mask';

const ControlledInput = forwardRef(
  ({ mask, name = '', label, classContainer, rules, defaultValue = '', className = '', children, onCustomChange, ...inputProps }, ref) => {
    const {
      control,
      formState: { errors },
    } = useFormContext();
    const error = get(errors, name);

    return (
      <Controller
        control={control}
        name={name}
        rules={rules && rules}
        defaultValue={defaultValue}
        render={({ field }) => {
          return (
            <div className={`relative mb-4 ${classContainer}`}>
              {label && (
                <label htmlFor={name} className="block text-gray-700 text-sm ml-2 mb-2">
                  {label}
                </label>
              )}
              <div className="flex flex-row h-10 relative">
                {mask ? (
                  <InputMask
                    mask={mask}
                    placeholder={inputProps?.placeholder ?? ''}
                    alwaysShowMask={false}
                    maskChar={' '}
                    onChange={field.onChange}
                    value={field.value}>
                    {(props) => (
                      <input
                        ref={ref}
                        className={`appearance-none border border-gray-300 pl-4 rounded-full w-full h-10 px-3 text-gray-700 leading-tight focus:outline-none ${className}`}
                        {...props}
                      />
                    )}
                  </InputMask>
                ) : (
                  <input
                    id={name}
                    ref={ref}
                    className={`appearance-none border border-gray-300 pl-4 rounded-full w-full h-10 px-3 text-gray-700 leading-tight focus:outline-none ${className}`}
                    {...field}
                    {...inputProps}
                    onChange={(value) => {
                      if (onCustomChange) {
                        const newValue = onCustomChange(value);
                        field.onChange?.(newValue);
                      } else {
                        field.onChange(value);
                      }
                    }}
                  />
                )}
                {error && <span className={'absolute bottom-[-16px] text-xs text-red-500'}>*{error?.message}</span>}
                {children}
              </div>
            </div>
          );
        }}
      />
    );
  }
);
ControlledInput.displayName = 'ControlledInput';
export default ControlledInput;
